import { useState, useEffect, useContext, Fragment } from 'react';
import { useSelector } from 'react-redux';
import {useTranslation} from 'react-i18next';

import ConvContext from '../../../store/conversation-context';
import ConversationSectionWrapper from './ConversationSectionWrapper';
import LessonComplete from './LessonComplete';
import Confetti from '../../UI/Confetti'

import parrot from '../../../assets/images/parrot-cutout-bitesize.png'
import ParrotBox from '../../UI/ParrotBox';

const WholeConversation = (props) => {
  const {t: translate } = useTranslation();
  const activeConversation = useSelector((state) => state.activeSection);
  const location = useSelector((state) => state.location)
  const [lessonComplete, setLessonComplete] = useState(false);
  const { convContext } = useContext(ConvContext);
  const currentLesson = useSelector((state) => state.currentLesson);
  const [showAnimation, setShowAnimation] = useState(false);
  let confettiTop = window.innerWidth < 768 ? '20px' : '-60px';
  let helpText = translate('practise-each-part');
  let parrotText = translate('tutorial-lesson-1');
  const sentences = convContext?.sentences;
  const totalSections = sentences?.length ? sentences.length : -1;
  const isTutorial = location === 'tutorial' ? true : false;

  if (parseInt(currentLesson) === 2) {
    helpText = translate('choose-correct-order')
    parrotText = translate('tutorial-lesson-2'); 
  }
  
  if (parseInt(currentLesson) === 3) {
    helpText = translate('have-a-conversation');
    parrotText = translate('tutorial-lesson-3');
  }

  const completeLesson = () => {
    setLessonComplete(true);
  };

  useEffect(() => {
    if (activeConversation === totalSections) {
      completeLesson();
    }

    if( activeConversation > 0 ) {
     setTimeout( function() {
      setShowAnimation(true)
     }, 200)
    }
  }, [activeConversation]);

  return (
    <div className="conversation">
      <div className='conversation__info-box'>
        <div className={`info-box__header ${isTutorial ? 'info-box__header--tutorial' : ''}`}>
          <img src={parrot} alt="Polly's tip" title="Polly's tip" className='info-box__icon' />
          <div className='info-box__content'>
            {isTutorial && (
              <Fragment>
                <p className='info-box__tip'>{translate('tutorial-title', {lesson: currentLesson})}</p> 
                <p className='info-box__prefix'>{helpText}</p> 
              </Fragment>
            )}
            {!isTutorial && (
              <Fragment>
                <span className='info-box__prefix'>Lesson Tip {/** TODO: translate this */}</span> 
                <p className='info-box__tip'>{helpText}</p> 
              </Fragment>
            )}
          </div>
        </div>
        { ! isTutorial && <button
          onClick={() => props.returnToStart()}
          className="info-box__quit"
        >
          {translate('quit')}
        </button>}
        <div className='progress-container'>
          {isTutorial && <div className='progress-bar' style={{width: `${(currentLesson / 3) * 100}%`}}></div>}
          {!isTutorial && (
            <Fragment>
              <div className='progress-bar' style={{width: `${(activeConversation / totalSections) * 100}%`}}></div>
              <div className='progress-bar-helper' style={{width: `${(activeConversation / totalSections) * 100}%`}}>
                <Confetti number={8} loopAnimation={false} playAnimation={showAnimation} toggleAnimation={setShowAnimation} extraStyles={{width: '100px', right: '-50px', top: confettiTop }}/>
              </div>
            </Fragment>
          )}
        </div>
      </div>
      {isTutorial && (
        <ParrotBox text={parrotText} bitesize={false} />
      )}
      {! sentences && <p style={{textAlign: 'center'}}>{translate('error-loading-conversation')}</p>}
      {sentences && <ConversationSectionWrapper sectionData={sentences} />}
      {lessonComplete && <LessonComplete returnToStart={props.returnToStart} />}
    </div>
  );
};

export default WholeConversation;
